module.exports = __webpack_public_path__ + "static/media/woman.e2af9404.png";